import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from "../../../../../services/common.service";
import { UserService } from "../../../../../services/user.service";

declare var Cleave: any;

@Component({
    selector: 'page-info-refund-index',
    templateUrl: './index.component.html',
})
export class PageInfoRefundIndexComponent implements OnInit {

    public formGroup: FormGroup;
    public accountSubjects: any;

    public $: any;
    public _: any;
    public moment: any;

    /* FOR TEMPORARY ASSIGNING */
    public tempData: any = {};

    constructor(
        public activatedRoute: ActivatedRoute,
        public formBuilder: FormBuilder,
        public commonService: CommonService,
        public userService: UserService,
    ) {
        this.$ = this.commonService.getJQuery();
        this._ = this.commonService.getLodash();
        this.moment = this.commonService.getMoment();
    }

    async ngOnInit() {
        /* SHOW LOADER */
        this.commonService.showPageLoader("読み込み中...");

        /* SET PAGE TITLE */
        this.commonService.setTitle(`返金先口座情報の入力 | バスブックマーク`);

        /* INITIALIZE FORM DATA */
        await this.initFormGroup();

        /* EXECUTE INLINE JAVASCRIPT */
        this.inlineJS();

        /* HIDE LOADER */
        this.commonService.hidePageLoader();
    }

    /* INITIALIZE FORM DATA */
    async initFormGroup() {
        this.tempData.formSubmitted = false;

        let groupID = this.activatedRoute.snapshot.paramMap.get("id");

        /* CHECK TOKEN */
        let authData: any = await this.userService.checkValidRefundLink({group: groupID});
        if (authData.status == "success") {
            this.tempData.authorized = true;
            this.tempData.authData = authData.data;
        } else {
            this.tempData.authorized = false;
        }

        /* ACCOUNT SUBJECT LIST */
        this.accountSubjects = [
            {id: 1, name: "普通"},
            {id: 2, name: "当座"},
            {id: 3, name: "その他"},
        ];

        /* GET PREVIOUS SUBMITTED DATA */
        let postData = this.commonService.getData("refundPostData");
        if (this._.isEmpty(postData)) {
            /* CHECK IF ALREADY UPDATED */
            if (authData.data && authData.data.accountNumber) {
                /* SET LAST SAVED DATA */
                postData = {...authData.data};

                /* SET WARNING MESSAGE */
                if (authData.data.refunded == 1) {
                    this.tempData.warningModal = {updated: true, message: "payment.refund.warning.refundedAlready"};
                } else {
                    this.tempData.warningModal = {updated: true, message: "payment.refund.warning.updatedAlready"};
                }

                this.tempData.infoUpdated = true;
                this.$("#warningModal").modal();
            } else {
                postData = {};

                /* CHECK IF REFUNDED */
                if (authData.data && authData.data.refunded == 1) {
                    /* SET WARNING MESSAGE */
                    this.tempData.warningModal = {updated: false, message: "payment.refund.warning.refunded"};
                    this.$("#warningModal").modal();
                }
            }
        }

        this.formGroup = this.formBuilder.group({
            // bankName: [{value: postData.bankName, disabled: this.tempData.infoUpdated}, [Validators.required]],
            // bankBranchName: [{value: postData.bankBranchName, disabled: this.tempData.infoUpdated}, [Validators.required]],
            // bankBranchNumber: [{value: postData.bankBranchNumber, disabled: this.tempData.infoUpdated}, [Validators.required]],
            bankName: [{value: '', disabled: this.tempData.infoUpdated}, [Validators.required]],
            bankBranchName: [{value: '', disabled: this.tempData.infoUpdated}, [Validators.required]],
            bankBranchNumber: [{value: '', disabled: this.tempData.infoUpdated}, [Validators.required]],
            accountSubject: [{value: (postData.accountSubject ? postData.accountSubject : 1), disabled: this.tempData.infoUpdated}, [Validators.required]],
            // accountName: [{value: postData.accountName, disabled: this.tempData.infoUpdated}, [Validators.required]],
            // accountNumber: [{value: postData.accountNumber, disabled: this.tempData.infoUpdated}, [Validators.required]],
            accountName: [{value: '', disabled: this.tempData.infoUpdated}, [Validators.required]],
            accountNumber: [{value: '', disabled: this.tempData.infoUpdated}, [Validators.required]],
        });

    }

    async onSubmit() {
        this.tempData.formSubmitted = true;

        /* FORM ZEN TO HAN */
        this.commonService.convertFormInputZenToHan(this.formGroup);

        if (this.formGroup.invalid) {
            /* SCROLL TO THE FIRST ERROR FORM */
            if (this.$(".form-error-msg:visible").length !== 0) {
                this.$("html, body").animate({scrollTop: (this.$(".form-error-msg:visible").first().offset().top - 90)}, 200);
            }

            return false;
        }

        /* SAVE DATA */
        let saveData = {...this.formGroup.value};
        saveData.id = this.tempData.authData.id;
        saveData.groupID = this.activatedRoute.snapshot.paramMap.get("id");
        saveData.token = this.tempData.authData.authToken;
        saveData.reservationID = this.tempData.authData.reservationID;
        saveData.customerName = this.tempData.authData.customerName;

        let accountSubjects = {};
        for (let item of this.accountSubjects) {
            accountSubjects[item.id] = item;
        }
        saveData.accountSubjects = accountSubjects;

        this.commonService.setData("refundPostData", saveData);
        /* END */

        /* REDIRECT TO NEXT STEP */
        this.commonService.redirectToRoute(this.commonService.routePaths.pageInfoRefundCheckout);
    }

    setFormValue(event: any, inputName: string) {
        this.formGroup.controls[inputName].setValue(event.target.value);
    }

    inlineJS() {
        let self = this;
        this.$(function() {
            self.formValidationInit();

            /* INIT INPUT ZEN TO HAN */
            self.commonService.zenToHan();
        });
    }

    formValidationInit() {
        new Cleave('.js-number', {
            blocks: [50]
        });
    }

}
